import { getSemanticPropsByNumber } from '@ui/utils/getSemanticProps';
import BigNumber from 'bignumber.js';
import { ForwardedRef, forwardRef, useMemo } from 'react';

import { AmountProps } from './Amount';
import { AmountUsd } from './AmountUsd';

const Component = (
  { value, ...p }: AmountProps,
  ref: ForwardedRef<HTMLParagraphElement>,
) => {
  const bigNum = useMemo(() => {
    if (typeof value === 'number') {
      return new BigNumber(value);
    }

    return value;
  }, [value]);

  return (
    <AmountUsd
      ref={ref}
      color={getSemanticPropsByNumber(bigNum).color}
      value={bigNum}
      data-cy-value={bigNum}
      {...p}
    />
  );
};

export const Pnl = forwardRef(Component);
